import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'wms-dialog-header',
  standalone: true,
  templateUrl: './wms-dialog-header.component.html',
  styleUrls: ['./wms-dialog-header.component.less'],
  imports: [
    CommonModule
  ]
})
export class WmsDialogHeaderComponent implements OnInit {

  @Input() title!: String;
  @Input() subheading!: String;
  @Input() showClose: Boolean = true;
  @Input() helpLink!: String;
  @Input() customClass!: String;
  @Input() helpTitle!: string;
  @Output() onClose = new EventEmitter<Boolean>();

  constructor() { }

  ngOnInit(): void {
  }
  handleClose() {
    this.onClose.emit(false)
  }
  
}